<script>
import axios from 'axios'
import Form from 'vform'

import { SupplierRoutes } from '../api/supplierRoutes'

import util from '../../../js/util'

export default {
  name: 'ConnectStoreModal',

  data: () => ({
    store_url: '',
    form: new Form({}),
    form_error: null,
  }),

  methods: {
    isValidURL(str) {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i',
      ) // fragment locator
      return !!pattern.test(str)
    },
    // validate shopify url
    validateShopify: function () {
      let store_url = this.store_url.trim()

      if (!this.isValidURL(store_url)) {
        // error message
        this.form_error = 'URL is invalid...'
        // empty response after 5 second
        setTimeout(this.emptyErrorResponse, 5000)
      } else {
        if (store_url !== '') {
          axios
            .post(SupplierRoutes.validateStoreUrl, {
              store_url: store_url,
            })
            .then((response) => {
              this.form_error = null
              window.location = config.supplierurl + '/shopify?store_url=' + store_url
            })
            .catch((error) => {
              this.form_error = error.response.data.errors.store_url[0]
            })
        }
      }
    },

    onBlur: function (element) {
      let store_url = this.store_url.trim()
      this.store_url = util.trimShopifyURL(store_url)
    },

    emptyErrorResponse: function () {
      this.form_error = null
    },

    // paste event for shopify store url field
    onPaste: function (element) {
      let clipboard_text = element.clipboardData.getData('Text')

      if (clipboard_text !== '') {
        this.store_url = clipboard_text
        $('#store_url').blur()
      }
    },
  },
}
</script>

<template>
  <transition name="modal-fade">
    <div
      id="connect-store-modal"
      class="modal my-modal-1 connect-store-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog">
        <div class="modal-box">
          <div class="modal-content">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4 padding-0">
                  <div class="purple-gradient">
                    <img
                      id="upgrade-your-plan-modal-rocket-img"
                      src="/images/connect.svg"
                    >
                  </div>
                </div>
                <div class="col-md-8 padding-0">
                  <div id="upgrade-plan-modal-content-container">
                    <div class="row">
                      <h3>Connect a store</h3>
                    </div>
                    <div class="row">
                      <div id="connect-store-page-upper-text connect-modal-text">
                        <p class="modal-text-connect">
                          Enter your existing
                          <b>Shopify store URL</b>
                          (store.myshopify.com) below to start importing products and start automating fulfillment. You
                          will be redirected to Shopify to connect your account to Zendrop.
                        </p>
                      </div>
                      <form
                        id="connect-store-form"
                        class="form-horizontal"
                        @submit.prevent="validateShopify()"
                        @keydown="form.onKeydown($event)"
                      >
                        <div class="row">
                          <div class="col-md-8">
                            <input
                              id="store_url"
                              v-model="store_url"
                              type="text"
                              name="store_url"
                              autocomplete="false"
                              class="form-control"
                              placeholder="store-name.myshopify.com"
                              required
                              :class="{ 'connect-store-error-border': form_error != null }"
                              @blur="onBlur"
                              @paste="onPaste"
                            >

                            <div id="connect-store-error-container">
                              <p
                                v-show="form_error != null"
                                class="connect-store-error"
                              >
                                {{ form_error }}
                              </p>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <v-button
                              id="connect-store-btn"
                              class="btn btn-success waves-effect waves-light grow-effect"
                              type="success"
                            >
                              Connect
                            </v-button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
